import type { Pixel } from "@pdfking/math"
import type { PDFReaderOptions } from "./PDFReaderOptions"
import type { PDFSplitResult } from "./PDFSplitter"

export type PDFConvertFunction = (
  input: PDFReaderOptions,
  resolution: Pixel
) => Promise<PDFSplitResult>
